<template>
  <div class="viewport viewport-with-top-nav viewport-compact align-items-center justify-content-center">
    <top-nav></top-nav>
    <spinner v-if="loading"></spinner>
    <template v-else>
      <div class="alert alert-warning mb-5" role="alert" aria-live="assertive" aria-atomic="true">
        <div class="alert-heading"><strong>{{ $t('SignLoanApplicationOtpPage.signingContract') }}</strong></div>
        <div class="small text-justify" v-html="$t('SignLoanApplicationOtpPage.warning')" />
      </div>
      <otp @otp-success="onOtpSuccess" :pin="pin" :signing-hash="signingHash"></otp>
    </template>
  </div>
</template>

<script>
  import store from '@shared/store'
  import Otp from '@shared/components/Otp'
  import TopNav from '@shared/components/TopNav'
  import LoanApplicationMixin from '@shared/mixins/LoanApplicationMixin'
  import settings from '@shared/settings'

  export default {
    components: { Otp, TopNav },
    mixins: [LoanApplicationMixin],
    data() {
      const draft = store.getDraft()
      return {
        signingHash: draft.loan.hash,
        pin: store.state.currentUser.pin,
        reference: draft.loan.reference,
        loading: false
      }
    },
    methods: {
      onOtpSuccess() {
        this.loading = true
        if (this.reference) {
          this.handleRegularLoanApplication()
        } else {
          this.handleComfortLoanApplication()
        }
      },
      redirectToNextPage: function () {
        const nextPage = settings.featureFlags.isSurveyEnabled() ? 'signing-survey' : 'customer-overview'
        this.$router.replace({ name: 'no-back', params: { page: nextPage } })
      },
      handleRegularLoanApplication() {
        return this.confirmRegularLoanApplication()
          .catch((e) => {
            this.$errorToast(this.$t('errors.signing.title'), this.signingErrorMessage(e))
          })
          .finally(() => {
            this.redirectToNextPage()
          })
      },
      signingErrorMessage(e) {
        return (e && e.response && e.response.data && e.response.data.reason) || this.$t('errors.signing.content')
      },
      handleComfortLoanApplication() {
        return this.submitComfortLoan()
          .catch(() => {
            this.$errorToast(this.$t('errors.application.title'), this.$t('errors.application.content'))
          })
          .finally(() => {
            this.redirectToNextPage()
          })
      }
    }
  }
</script>
